import CryptoJS from 'crypto-js';
import { env } from '../../../../env';

const SECRET_KEY = env.REACT_APP_GUIDE_PREFILL_SECRET;

// Validar que la secret key esté configurada
if (!SECRET_KEY) {
	console.error(
		'[hashUtils] ERROR: REACT_APP_GUIDE_PREFILL_SECRET no está definida en las variables de entorno',
	);
}

/**
 * Crea un hash seguro con HMAC-SHA256 y datos comprimidos
 * Incluye timestamp y expiración para prevenir replay attacks
 * @throws {Error} Si REACT_APP_GUIDE_PREFILL_SECRET no está configurada
 */
export const createSecureHash = (data, timestamp = Date.now()) => {
	// Validar que la secret key esté configurada
	if (!SECRET_KEY) {
		throw new Error(
			'REACT_APP_GUIDE_PREFILL_SECRET no está configurada. Contacte al administrador del sistema.',
		);
	}

	// 1. Agregar timestamp para prevenir replay attacks
	const payload = {
		...data,
		_ts: timestamp,
		_exp: timestamp + 5 * 60 * 1000, // Expira en 5 minutos
	};

	// 2. Comprimir datos
	const jsonString = JSON.stringify(payload);
	const compressed = CryptoJS.enc.Base64.stringify(
		CryptoJS.enc.Utf8.parse(jsonString),
	);

	// 3. Generar firma HMAC
	const signature = CryptoJS.HmacSHA256(compressed, SECRET_KEY).toString();

	// 4. Combinar datos + firma
	return `${compressed}.${signature}`;
};

/**
 * Decodifica y valida un hash seguro
 * @throws {Error} Si el hash es inválido, expirado o la firma no coincide
 */
export const decodeSecureHash = hash => {
	// Validar que la secret key esté configurada
	if (!SECRET_KEY) {
		throw new Error(
			'REACT_APP_GUIDE_PREFILL_SECRET no está configurada. Contacte al administrador del sistema.',
		);
	}

	const [compressed, signature] = hash.split('.');

	if (!compressed || !signature) {
		throw new Error('Hash inválido: formato incorrecto');
	}

	// 1. Verificar firma
	const expectedSignature = CryptoJS.HmacSHA256(
		compressed,
		SECRET_KEY,
	).toString();

	if (signature !== expectedSignature) {
		throw new Error('Hash inválido: firma no coincide');
	}

	// 2. Descomprimir
	const jsonString = CryptoJS.enc.Base64.parse(compressed).toString(
		CryptoJS.enc.Utf8,
	);

	const data = JSON.parse(jsonString);

	// 3. Validar expiración
	if (Date.now() > data._exp) {
		throw new Error(
			'Hash expirado: los datos pre-llenados ya no son válidos',
		);
	}

	// 4. Limpiar metadatos internos
	delete data._ts;
	delete data._exp;

	return data;
};

/**
 * Valida la estructura de datos de pre-llenado
 */
export const validatePrefillData = data => {
	if (!data || typeof data !== 'object') {
		throw new Error('Datos de pre-llenado inválidos');
	}

	if (data.category !== 'residuos') {
		throw new Error('Categoría no soportada para pre-llenado');
	}

	if (!data.residuos_operation_type) {
		throw new Error('Tipo de operación no especificado');
	}

	if (!Array.isArray(data.items) || data.items.length === 0) {
		throw new Error('No hay items para pre-llenar');
	}

	return true;
};
